import { FC, useState } from 'react'
import { WalletItemModel } from '@/services/apis/wallet/models'
import { WalletCoin } from '@/services/apis/coin/models'
import AddressQRCode from '../AddressQRCode'
import styles from './index.module.scss'
import { useCurrentReceiveAddressGroup } from '@/hooks/address'
import { ReactComponent as CloseModalIcon } from '@/assets/icons/closeModal.svg'
import { ReactComponent as ArrowRightIcon } from '@/assets/icons/arrowRight.svg'
import { Tabs, TabsProps } from 'antd'
import { AddrType, ReceiveAddressGroupItem } from '@/services/apis/address/models'
import i18n, { useTranslation } from '@/services/i18n'
import ReceiveAddressDrawer from '../ReceiveAddressDrawer'

interface AddressTabProps {
  items: TabsProps['items']
  onChange: (activeKey: AddrType) => void
  activeKey: AddrType
}

const AddressTab: FC<AddressTabProps> = ({ items, onChange, activeKey }) => {
  const len = items?.length ?? 0
  const style = len < 2 ? { display: 'none' } : undefined
  return (
    <Tabs
      items={items}
      onChange={val => onChange(val as AddrType)}
      activeKey={activeKey}
      renderTabBar={(props, DefaultTabBar) => (
        <DefaultTabBar {...props} className={styles.addressTabBar} style={style} />
      )}
    />
  )
}

interface ReceiveContentProps {
  coin: WalletCoin
  wallet: WalletItemModel
}

const ReceiveContent: FC<ReceiveContentProps> = ({ coin, wallet }) => {
  const { t } = useTranslation()
  const { addressGroup, activeAddressType, setActiveAddressType, addressTabs, currAddr } =
    useCurrentReceiveAddressGroup(wallet.accountKey, coin.coinKey)
  return (
    <>
      <div className={styles.container}>
        <span className={styles.walletName}>{wallet.accountName}</span>
        <div className={styles.qrCode}>
          <AddressQRCode value={currAddr} logo={coin.logoUrl} />
        </div>
        {addressGroup?.addressList?.length && (
          <AddressTab
            items={addressTabs}
            activeKey={activeAddressType}
            onChange={setActiveAddressType}
          />
        )}
        <p className={styles.address}>{currAddr}</p>
        <span className={styles.hint}>
          {t('wallet.detail.receiveTip', { coinName: coin.coinName })}
        </span>
      </div>
      <ReceiveFooter
        isMulti={coin.isMultipleAddress === 1}
        walletKey={wallet.accountKey}
        coinKey={coin.coinKey}
        addressGroup={addressGroup}
      />
    </>
  )
}

interface ReceiveFooterProps {
  isMulti: boolean
  walletKey: string
  coinKey: string
  addressGroup?: ReceiveAddressGroupItem
}

const ReceiveFooter: FC<ReceiveFooterProps> = ({ isMulti, walletKey, coinKey, addressGroup }) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()
  return isMulti ? (
    <>
      <div className={styles.footer}>
        <div className={styles.allAddressBtn} onClick={() => setOpen(true)}>
          {t('wallet.address.allAddress')}
          <div className={styles.arrowIcon}>
            <ArrowRightIcon />
          </div>
        </div>
      </div>
      <ReceiveAddressDrawer
        open={open}
        onClose={() => setOpen(false)}
        walletKey={walletKey}
        coinKey={coinKey}
        addressGroup={addressGroup}
      />
    </>
  ) : null
}
const { t } = i18n
const open = (coin: WalletCoin, wallet: WalletItemModel) => {
  window.shModal.info({
    width: 335,
    content: <ReceiveContent coin={coin} wallet={wallet} />,
    icon: null,
    closeIcon: <CloseModalIcon />,
    title: (
      <div style={{ marginBottom: '22px' }}>
        <h3 className={styles.title}>{t('common.receive')}</h3>
        <div style={{ textAlign: 'center' }}>
          <span className={styles.netName}>{coin?.networkName}</span>
        </div>
      </div>
    ),
    footer: null,
    closable: true,
  })
}

export default {
  open,
}
